import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { AuthKeycloakService } from './auth-keycloak.service';

@Injectable()
export class FilterService extends BaseService {
  private controller = 'filter';
  constructor(
    private http: HttpClient, 
    protected authKeycloakService: AuthKeycloakService
  ) {
    super(authKeycloakService);
  }

  seefilters(): Observable<any> {
    return this.http
      .get(`${this.url}${this.controller}${'/my-filters/'}`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  viewid(id: number): Observable<any> {
    return this.http
      .get(`${this.url}${this.controller}${'/view/'}${id}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  viewall(): Observable<any> {
    return this.http
      .get(`${this.url}${this.controller}${'/view-all/'}`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  delete(id: number): Observable<any> {
    return this.http
      .delete(`${this.url}${this.controller}${'/excluir-filtro/'}${id}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }
  
  vinculatedprojects(id: number): Observable<any> {
    return this.http
      .get(`${this.url}${'/project/view/'}${id}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }


}